export default __webpack_public_path__ + "static/media/chevronRight-gray.418a4869.svg";